export const safeReplace = (string: string, ...args: [string, string]): string => string && string.replace(...args);

export const safeLowerCase = (string: string) => string && string.toLowerCase();

export const safeUpperCase = (string: string) => string && string.toUpperCase();

export const escapeString = (string: string) => string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

export const appendIfDoestStartWith = (prefix: string): ((str: string) => string) => {
  return (str: string): string => {
    if (str.startsWith(prefix)) {
      return str;
    }
    return `${prefix}${str}`;
  };
};
export const uppercaseFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);
